import apiClient from '@/services/axios'

export async function put(venueSetupId, venueSectionId, venueTable) {
  var response = await apiClient.put(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/venue-setups/' + venueSetupId + '/venue-sections/' + venueSectionId + '/venue-tables/' + venueTable.id, venueTable);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to put venue section.')
}
